import { ChatIcon, PlusIcon } from "@phosphor-icons/react";
import { ReactNode, SVGAttributes } from "react";

export function ThirtySecondsIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? 100}
      height={props.height ?? 100}
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_274)">
        <path
          d="M17.2869 33.6327C18.951 31.4423 22.0755 31.0157 24.2655 32.6795C26.4556 34.3433 26.8826 37.4677 25.2188 39.6581C21.4014 44.6831 18.2385 50.1443 15.8177 55.8904C14.7498 58.4255 11.8293 59.6145 9.29424 58.5467C6.75951 57.4789 5.57018 54.5583 6.63799 52.0233C9.38256 45.5092 12.9652 39.3214 17.2869 33.6327Z"
          fill="white"
        />
        <path
          d="M52.0237 6.63791C54.5587 5.5701 57.4793 6.75911 58.5471 9.29416C59.6149 11.8289 58.4256 14.7498 55.8908 15.8176C50.1444 18.2388 44.6831 21.4014 39.6585 25.2184C37.4684 26.8822 34.344 26.4555 32.6798 24.2655C31.016 22.0754 31.4427 18.9506 33.6328 17.2865C39.3208 12.9651 45.5089 9.38248 52.0237 6.63791Z"
          fill="white"
        />
        <path
          d="M0.682656 74.381C1.02332 71.6513 3.51223 69.7149 6.24152 70.0556C8.97082 70.3963 10.9079 72.8848 10.5672 75.6145C10.1592 78.8826 9.96094 81.9526 9.96094 85C9.96094 88.047 10.1592 91.117 10.5672 94.3855C10.9079 97.1148 8.97115 99.6037 6.24186 99.944C3.51256 100.285 1.02365 98.348 0.682988 95.6187C0.229766 91.9882 0 88.4156 0 85C0 81.5841 0.229766 78.0114 0.682656 74.381Z"
          fill="white"
        />
        <path
          d="M72.489 158.942C76.8814 159.68 80.9737 160.039 84.9999 160.039C89.1161 160.039 93.3259 159.683 97.5122 158.98C100.225 158.525 102.793 160.355 103.248 163.067C103.704 165.78 101.874 168.348 99.161 168.804C94.4313 169.598 89.6669 170 84.9999 170C80.4142 170 75.7817 169.596 70.8378 168.765C68.1251 168.309 66.2959 165.741 66.7518 163.028C67.2077 160.315 69.7763 158.486 72.489 158.942Z"
          fill="white"
        />
        <path
          d="M99.1608 168.804C101.873 168.348 103.703 165.78 103.248 163.068C102.793 160.355 100.225 158.525 97.5119 158.98C93.326 159.683 89.1162 160.039 85 160.039V170C89.667 170 94.4313 169.598 99.1608 168.804Z"
          fill="white"
        />
        <path
          d="M74.3809 0.682988C78.0114 0.229766 81.584 0 85 0C107.704 0 129.05 8.84166 145.104 24.8957C161.158 40.9504 170 62.2957 170 85C170 95.1801 168.209 105.154 164.677 114.644C161.353 123.573 156.582 131.827 150.497 139.176C148.742 141.295 145.603 141.59 143.484 139.835C141.366 138.081 141.07 134.941 142.825 132.823C148.197 126.336 152.408 119.05 155.341 111.169C158.459 102.794 160.039 93.9897 160.039 85C160.039 43.6233 126.377 9.96094 85 9.96094C81.9526 9.96094 78.8826 10.1592 75.6141 10.5672C72.8848 10.9079 70.3956 8.97115 70.0549 6.24186C69.7146 3.51256 71.6513 1.02332 74.3809 0.682988Z"
          fill="white"
        />
        <path
          d="M85 0V9.96094C126.377 9.96094 160.039 43.6233 160.039 85C160.039 93.9897 158.459 102.794 155.341 111.169C152.408 119.05 148.197 126.336 142.825 132.823C141.07 134.941 141.366 138.081 143.484 139.835C145.603 141.59 148.742 141.294 150.497 139.176C156.582 131.827 161.353 123.573 164.677 114.644C168.209 105.154 170 95.1801 170 85C170 62.2957 161.158 40.9504 145.104 24.8957C129.05 8.84166 107.704 0 85 0Z"
          fill="white"
        />
        <path
          d="M132.823 142.825C134.942 141.07 138.081 141.366 139.836 143.484C141.59 145.603 141.295 148.742 139.176 150.496C131.827 156.582 123.573 161.353 114.644 164.676C112.066 165.636 109.199 164.324 108.239 161.746C107.28 159.168 108.592 156.3 111.169 155.341C119.051 152.408 126.336 148.196 132.823 142.825Z"
          fill="white"
        />
        <path
          d="M37.2207 142.754C35.103 140.999 31.9633 141.293 30.2078 143.41C28.4524 145.528 28.7459 148.668 30.8636 150.423C38.2682 156.561 46.5146 161.347 55.3735 164.645C57.9514 165.605 60.8191 164.294 61.7787 161.716C62.7386 159.138 61.4271 156.27 58.8492 155.31C51.0398 152.402 43.7627 148.178 37.2207 142.754Z"
          fill="white"
        />
        <path
          d="M5.40782 114.593C4.44925 112.015 5.7621 109.148 8.34032 108.189C10.9185 107.23 13.7856 108.543 14.7445 111.122C17.686 119.032 21.8908 126.321 27.2419 132.786C28.9957 134.905 28.6998 138.044 26.5811 139.798L26.5808 139.798C24.4618 141.552 21.3224 141.256 19.5686 139.137C13.5037 131.811 8.73942 123.553 5.40782 114.593Z"
          fill="white"
        />
        <path
          d="M50.3625 56.376C50.6612 52.4507 52.1758 49.3787 54.9065 47.16C57.6372 44.9413 61.1785 43.832 65.5305 43.832C68.4318 43.832 70.9278 44.3653 73.0185 45.432C75.1518 46.456 76.7518 47.864 77.8185 49.656C78.9278 51.448 79.4825 53.4747 79.4825 55.736C79.4825 58.3813 78.7145 60.664 77.1785 62.584C75.6852 64.504 73.7225 65.7413 71.2905 66.296V66.616C74.0638 67.2987 76.2612 68.6427 77.8825 70.648C79.5038 72.6533 80.3145 75.2773 80.3145 78.52C80.3145 80.952 79.7598 83.1493 78.6505 85.112C77.5412 87.032 75.8772 88.5467 73.6585 89.656C71.4398 90.7653 68.7732 91.32 65.6585 91.32C61.1358 91.32 57.4238 90.1467 54.5225 87.8C51.6212 85.4107 49.9998 82.04 49.6585 77.688H55.2905C55.5892 80.248 56.6345 82.3387 58.4265 83.96C60.2185 85.5813 62.6078 86.392 65.5945 86.392C68.5812 86.392 70.8425 85.624 72.3785 84.088C73.9572 82.5093 74.7465 80.4827 74.7465 78.008C74.7465 74.808 73.6798 72.504 71.5465 71.096C69.4132 69.688 66.1918 68.984 61.8825 68.984H60.4105V64.12H61.9465C65.8718 64.0773 68.8372 63.4373 70.8425 62.2C72.8478 60.92 73.8505 58.9573 73.8505 56.312C73.8505 54.0507 73.1038 52.2373 71.6105 50.872C70.1598 49.5067 68.0692 48.824 65.3385 48.824C62.6932 48.824 60.5598 49.5067 58.9385 50.872C57.3172 52.2373 56.3572 54.072 56.0585 56.376H50.3625ZM86.258 67.384C86.258 60.0453 87.4527 54.328 89.842 50.232C92.2313 46.0933 96.4127 44.024 102.386 44.024C108.317 44.024 112.477 46.0933 114.866 50.232C117.255 54.328 118.45 60.0453 118.45 67.384C118.45 74.8507 117.255 80.6533 114.866 84.792C112.477 88.9307 108.317 91 102.386 91C96.4127 91 92.2313 88.9307 89.842 84.792C87.4527 80.6533 86.258 74.8507 86.258 67.384ZM112.69 67.384C112.69 63.672 112.434 60.536 111.922 57.976C111.453 55.3733 110.45 53.2827 108.914 51.704C107.421 50.1253 105.245 49.336 102.386 49.336C99.4847 49.336 97.266 50.1253 95.73 51.704C94.2367 53.2827 93.234 55.3733 92.722 57.976C92.2527 60.536 92.018 63.672 92.018 67.384C92.018 71.224 92.2527 74.4453 92.722 77.048C93.234 79.6507 94.2367 81.7413 95.73 83.32C97.266 84.8987 99.4847 85.688 102.386 85.688C105.245 85.688 107.421 84.8987 108.914 83.32C110.45 81.7413 111.453 79.6507 111.922 77.048C112.434 74.4453 112.69 71.224 112.69 67.384ZM61.5177 121.32C59.011 121.32 56.9577 120.747 55.3577 119.6C53.7843 118.427 52.9043 116.84 52.7177 114.84H55.5977C55.731 116.067 56.3043 117.067 57.3177 117.84C58.3577 118.587 59.7443 118.96 61.4777 118.96C62.9977 118.96 64.1843 118.6 65.0377 117.88C65.9177 117.16 66.3577 116.267 66.3577 115.2C66.3577 114.453 66.1177 113.84 65.6377 113.36C65.1577 112.88 64.5443 112.507 63.7977 112.24C63.0777 111.947 62.091 111.64 60.8377 111.32C59.211 110.893 57.891 110.467 56.8777 110.04C55.8643 109.613 54.9977 108.987 54.2777 108.16C53.5843 107.307 53.2377 106.173 53.2377 104.76C53.2377 103.693 53.5577 102.707 54.1977 101.8C54.8377 100.893 55.7443 100.173 56.9177 99.64C58.091 99.1067 59.4243 98.84 60.9177 98.84C63.2643 98.84 65.1577 99.44 66.5977 100.64C68.0377 101.813 68.811 103.44 68.9177 105.52H66.1177C66.0377 104.24 65.531 103.213 64.5977 102.44C63.691 101.64 62.4377 101.24 60.8377 101.24C59.4243 101.24 58.2777 101.573 57.3977 102.24C56.5177 102.907 56.0777 103.733 56.0777 104.72C56.0777 105.573 56.331 106.28 56.8377 106.84C57.371 107.373 58.0243 107.8 58.7977 108.12C59.571 108.413 60.611 108.747 61.9177 109.12C63.491 109.547 64.7443 109.96 65.6777 110.36C66.611 110.76 67.411 111.347 68.0777 112.12C68.7443 112.893 69.091 113.92 69.1177 115.2C69.1177 116.373 68.7977 117.427 68.1577 118.36C67.5177 119.267 66.6243 119.987 65.4777 120.52C64.331 121.053 63.011 121.32 61.5177 121.32ZM92.9483 108.96C92.9483 109.92 92.9216 110.653 92.8683 111.16H74.7483C74.8283 112.813 75.2283 114.227 75.9483 115.4C76.6683 116.573 77.6149 117.467 78.7883 118.08C79.9616 118.667 81.2416 118.96 82.6283 118.96C84.4416 118.96 85.9616 118.52 87.1883 117.64C88.4416 116.76 89.2683 115.573 89.6683 114.08H92.6283C92.0949 116.213 90.9483 117.96 89.1883 119.32C87.4549 120.653 85.2683 121.32 82.6283 121.32C80.5749 121.32 78.7349 120.867 77.1083 119.96C75.4816 119.027 74.2016 117.72 73.2683 116.04C72.3616 114.333 71.9083 112.347 71.9083 110.08C71.9083 107.813 72.3616 105.827 73.2683 104.12C74.1749 102.413 75.4416 101.107 77.0683 100.2C78.6949 99.2933 80.5483 98.84 82.6283 98.84C84.7083 98.84 86.5216 99.2933 88.0683 100.2C89.6416 101.107 90.8416 102.333 91.6683 103.88C92.5216 105.4 92.9483 107.093 92.9483 108.96ZM90.1083 108.88C90.1349 107.253 89.8016 105.867 89.1083 104.72C88.4416 103.573 87.5216 102.707 86.3483 102.12C85.1749 101.533 83.8949 101.24 82.5083 101.24C80.4283 101.24 78.6549 101.907 77.1883 103.24C75.7216 104.573 74.9083 106.453 74.7483 108.88H90.1083ZM95.5911 110.08C95.5911 107.813 96.0444 105.84 96.9511 104.16C97.8578 102.453 99.1111 101.147 100.711 100.24C102.311 99.3067 104.138 98.84 106.191 98.84C108.884 98.84 111.098 99.5067 112.831 100.84C114.591 102.173 115.724 103.987 116.231 106.28H113.231C112.858 104.707 112.044 103.48 110.791 102.6C109.564 101.693 108.031 101.24 106.191 101.24C104.724 101.24 103.404 101.573 102.231 102.24C101.058 102.907 100.124 103.907 99.4311 105.24C98.7644 106.547 98.4311 108.16 98.4311 110.08C98.4311 112 98.7644 113.627 99.4311 114.96C100.124 116.293 101.058 117.293 102.231 117.96C103.404 118.627 104.724 118.96 106.191 118.96C108.031 118.96 109.564 118.52 110.791 117.64C112.044 116.733 112.858 115.48 113.231 113.88H116.231C115.724 116.12 114.591 117.92 112.831 119.28C111.071 120.64 108.858 121.32 106.191 121.32C104.138 121.32 102.311 120.867 100.711 119.96C99.1111 119.027 97.8578 117.72 96.9511 116.04C96.0444 114.333 95.5911 112.347 95.5911 110.08Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_274">
          <rect width="170" height="170" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ChartBarSquareIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      strokeWidth={1.5}
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
      />
    </svg>
  );
}

export function DocumentChartBarIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      strokeWidth={1.5}
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
      />
    </svg>
  );
}

export function NewspaperIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      strokeWidth={1.5}
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
      />
    </svg>
  );
}

export function ArrowExternal(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 6 6"
      width={props.width ?? 7}
      height={props.height ?? 7}
      {...props}
    >
      <path
        d="M1.25215 5.54731L0.622742 4.9179L3.78169 1.75597H1.3834L1.38936 0.890915H5.27615V4.78069H4.40513L4.41109 2.38538L1.25215 5.54731Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function AiStarIcon(
  props: SVGAttributes<SVGElement> & { defs?: ReactNode }
) {
  return (
    <svg
      width={props.width ?? "55"}
      height={props.height ?? "57"}
      viewBox="0 0 55 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.7188 0.388887C26.7188 15.9219 39.3106 28.5139 54.8438 28.5139C39.3106 28.5139 26.7188 41.1058 26.7188 56.6389C26.7188 41.1058 14.1267 28.5139 -1.40625 28.5139C14.1267 28.5139 26.7188 15.9219 26.7188 0.388887Z"
        fill={props.color ?? "url(#paint0_linear_282_445)"}
      />
      <defs>
        {props.defs ?? (
          <linearGradient
            id="paint0_linear_282_445"
            x1="37.5"
            y1="7.37501"
            x2="37.5"
            y2="63.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2400FF" />
            <stop offset="1" stopColor="#00FFD1" />
          </linearGradient>
        )}
      </defs>
    </svg>
  );
}

export function LibertifyLogo(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 52 45"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
    >
      <path
        d="m15.632 35.44 4.083-23.138c.32-1.912.256-3.76-.446-5.546C17.737 2.868 14.037 0 9.826 0H0v.51c2.297.829 4.083 2.804 4.913 5.227.064.127.064.318.127.446.256 1.083.256 2.23.064 3.378L.957 32.953c-.255 1.275-.191 2.677.064 3.952C2.106 41.558 6.125 45 10.847 45h10.017v-.446c-2.36-.829-4.211-2.741-5.04-5.227-.065-.127-.065-.319-.128-.446-.255-1.147-.255-2.295-.064-3.442Z"
        fill={props.fill ?? "currentColor"}
      />
      <path
        d="M33.497 0c-7.146 0-10.719 5.737-11.995 13.831h18.503C47.151 13.831 50.724 8.095 52 0H33.497ZM21.12 16.062l-2.425 13.832h9.187c7.146 0 10.72-5.737 11.995-13.832H21.12Z"
        fill={props.color ?? "#3BD4CA"}
      />
    </svg>
  );
}

export function DocustreamLogo(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      width={props.width}
      height={props.height}
      x="73"
      y="219"
      overflow="visible"
      preserveAspectRatio="xMinYMin"
      viewBox="0 0 54.15 54.14"
      style={props.style}
    >
      <path
        id="Layer_2-2"
        fill={props.color ?? "currentColor"}
        fillOpacity="1"
        strokeWidth="0"
        d="M26.93 0C11.97.07 0 12.52 0 27.48v26.08c0 .32.26.58.58.58h6.53c.32 0 .58-.26.58-.58V27.42c0-10.8 8.69-19.79 19.49-19.73 10.6.06 19.21 8.67 19.27 19.27.06 10.8-8.92 19.49-19.72 19.49h-7.49V27.07c0-4.62 4.01-8.32 8.74-7.79 3.59.4 6.49 3.3 6.89 6.89.36 3.23-1.26 6.13-3.8 7.64v-6.74c0-2.2-1.79-3.99-3.99-3.99s-3.99 1.79-3.99 3.99v14.95c0 .32.26.58.58.58h3.15c8.45 0 15.55-6.64 15.79-15.09.25-8.91-7.05-16.22-15.97-15.97-8.45.24-15.09 7.34-15.09 15.79v26.23c0 .32.26.58.58.58h14.54c14.97 0 27.41-11.97 27.48-26.93C54.22 12.17 41.97-.07 26.93 0"
      ></path>
    </svg>
  );
}

export function DocumentIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "23"}
      height={props.height ?? "30"}
      fill="none"
      viewBox="0 0 23 30"
      {...props}
    >
      <path
        fill={props.fill ?? "#FE977D"}
        fillRule="evenodd"
        d="M3.833 0C1.713 0 0 1.675 0 3.75v22.5C0 28.325 1.712 30 3.833 30h15.334C21.287 30 23 28.325 23 26.25V9.45c0-.45-.166-.875-.46-1.225L15.908.65A1.95 1.95 0 0 0 14.452 0zm9.584 11.875c1.405 0 2.555-1.125 2.555-2.5s-1.15-2.5-2.555-2.5S10.86 8 10.86 9.375s1.15 2.5 2.556 2.5m-5.035-.437c.256-.363.805-.363 1.048 0l4 5.7 2.057-2.75a.656.656 0 0 1 1.035 0l2.504 3.337c.307.412 0 1-.511 1H4.473c-.512 0-.819-.562-.525-.975zM3.833 21.25h11.5v1.25h-11.5zm15.334 2.5H3.833V25h15.334z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function Drag(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? "18"}
      height={props.height ?? "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.70979 3.04765V1.97962H3.19289L4.41731 0.755201L3.66211 0L1.14844 2.51363L3.66211 5.0273L4.41731 4.2721L3.19289 3.04765H6.70979Z"
        fill={props.fill ?? "#FE977D"}
      />
      <path
        d="M13.2768 4.2721L14.032 5.0273L16.5457 2.51363L14.032 0L13.2768 0.755201L14.5013 1.97962H10.9844V3.04765H14.5013L13.2768 4.2721Z"
        fill={props.fill ?? "#FE977D"}
      />
      <path
        d="M15.2503 8.92179C15.0472 8.9189 14.847 8.95422 14.6623 9.0251C14.4149 8.1401 13.4649 7.63375 12.5856 7.94561C12.646 6.8082 11.5237 5.95933 10.4495 6.34357V4.64969C10.369 2.52738 7.32567 2.52777 7.24543 4.64972C7.24543 4.64969 7.24543 8.38777 7.24543 8.38777H6.71141C5.82805 8.38777 5.10938 9.10641 5.10938 9.98981V12.3929C5.11981 14.8798 6.69628 15.093 6.71145 17.199C6.71141 17.199 6.71141 18 6.71141 18H15.2556V17.218C15.2628 15.0758 16.8587 14.8378 16.8576 12.3263C16.8577 12.3263 16.8577 10.5238 16.8577 10.5238C16.8577 9.64046 16.1366 8.92179 15.2503 8.92179ZM15.7896 12.3263C15.7821 14.3977 14.3173 14.653 14.1962 16.932H7.77139C7.71831 16.0482 7.40353 15.1848 6.87162 14.4755C6.42394 13.8786 6.1774 13.139 6.1774 12.3929V9.98981C6.1774 9.69532 6.41696 9.4558 6.71141 9.4558H7.24543V12.6599H8.31345C8.31345 11.7379 8.31345 5.8887 8.31345 4.64969C8.31345 4.35523 8.55301 4.11567 8.84746 4.11567C9.14192 4.11567 9.38148 4.35523 9.38148 4.64969V11.5918H10.4495C10.4495 10.7826 10.4495 8.63246 10.4495 7.85376C10.4495 7.55931 10.689 7.31975 10.9835 7.31975C11.278 7.31975 11.5175 7.55931 11.5175 7.85376V11.5918H12.5856C12.5856 10.9564 12.5856 10.1044 12.5856 9.4558C12.5856 9.16131 12.8251 8.92179 13.1196 8.92179C13.414 8.92179 13.6536 9.16134 13.6536 9.4558C13.6533 11.679 13.6536 10.1443 13.6536 11.5919C13.7632 11.5919 13.258 11.592 14.7216 11.5918V10.4891C14.7223 10.2029 14.9645 9.976 15.2504 9.98981C15.5478 9.98981 15.7896 10.2293 15.7896 10.5238V12.3263Z"
        fill={props.fill ?? "#FE977D"}
      />
    </svg>
  );
}

export function StrokeIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? "20"}
      height={props.height ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_332_5496)">
        <path
          d="M19.4141 0H0.585938C0.262344 0 0 0.172697 0 0.385714V1.41429C0 1.6273 0.262344 1.8 0.585938 1.8H19.4141C19.7377 1.8 20 1.6273 20 1.41429V0.385714C20 0.172697 19.7377 0 19.4141 0Z"
          fill={props.fill ?? "#FE977D"}
        />
        <path
          d="M19.4141 5.40002H0.585938C0.262344 5.40002 0 5.6418 0 5.94002V8.46002C0 8.75825 0.262344 9.00002 0.585938 9.00002H19.4141C19.7377 9.00002 20 8.75825 20 8.46002V5.94002C20 5.6418 19.7377 5.40002 19.4141 5.40002Z"
          fill={props.fill ?? "#FE977D"}
        />
        <path
          d="M19.4141 12.6H0.585938C0.262344 12.6 0 12.8789 0 13.2231V17.3769C0 17.721 0.262344 18 0.585938 18H19.4141C19.7377 18 20 17.721 20 17.3769V13.2231C20 12.8789 19.7377 12.6 19.4141 12.6Z"
          fill={props.fill ?? "#FE977D"}
        />
        <g clipPath="url(#clip1_332_5496)">
          <path
            d="M-54 10C-54 -25.3467 -25.3467 -54 10 -54C45.3467 -54 74 -25.3467 74 10C74 45.3467 45.3467 74 10 74C-25.3467 74 -54 45.3467 -54 10ZM10 48.2715C31.1367 48.2715 48.2715 31.1367 48.2715 10C48.2715 -11.1367 31.1367 -28.2715 10 -28.2715C-11.1367 -28.2715 -28.2715 -11.1367 -28.2715 10C-28.2715 31.1367 -11.1367 48.2715 10 48.2715Z"
            fill={props.fill ?? "#FE977D"}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_332_5496">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_332_5496">
          <rect
            width="128"
            height="128"
            fill="white"
            transform="translate(-54 -54)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AnimationsIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={props.width ?? "18"}
      height={props.height ?? "18"}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_329_4715)">
        <path
          d="M5.24479 15.7635C5.2007 15.7649 5.15632 15.7656 5.11194 15.7656C2.70244 15.7656 0.742205 13.8053 0.742205 11.3959C0.742205 8.98642 2.70244 7.02614 5.11194 7.02614C5.15632 7.02614 5.20074 7.02685 5.24479 7.02818C5.44942 7.0349 5.62087 6.87362 5.62721 6.66877C5.63356 6.46392 5.47265 6.29269 5.2678 6.28635C5.2161 6.28475 5.164 6.28394 5.11194 6.28394C2.29319 6.28394 0 8.57713 0 11.3959C0 14.2146 2.29319 16.5078 5.11194 16.5078C5.164 16.5078 5.21614 16.507 5.2678 16.5054C5.47268 16.4991 5.63356 16.3278 5.62721 16.123C5.62087 15.9181 5.44897 15.7568 5.24479 15.7635Z"
          fill={props.fill ?? "currentColor"}
        />
        <path
          d="M9.78252 15.7383C9.62034 15.7564 9.45431 15.7656 9.28906 15.7656C6.87957 15.7656 4.91933 13.8054 4.91933 11.3959C4.91933 8.98642 6.87957 7.02618 9.28906 7.02618C9.45435 7.02618 9.62038 7.03542 9.78248 7.05356C9.9864 7.07617 10.1698 6.9298 10.1926 6.7261C10.2154 6.52241 10.0689 6.33878 9.86516 6.31596C9.67571 6.2947 9.48185 6.28394 9.28906 6.28394C6.47031 6.28394 4.17712 8.57713 4.17712 11.3959C4.17712 14.2146 6.47031 16.5078 9.28906 16.5078C9.48181 16.5078 9.67564 16.497 9.86512 16.4758C10.0688 16.453 10.2154 16.2694 10.1926 16.0657C10.1698 15.8621 9.98618 15.7155 9.78252 15.7383Z"
          fill={props.fill ?? "currentColor"}
        />
        <path
          d="M18.4737 12.6609C18.281 12.5911 18.0682 12.6907 17.9985 12.8835C17.3743 14.6073 15.7227 15.7655 13.8887 15.7655C11.4793 15.7655 9.51906 13.8053 9.51906 11.3959C9.51906 8.98646 11.4793 7.02626 13.8887 7.02626C15.7247 7.02626 17.3769 8.18614 17.9999 9.91247C18.0695 10.1053 18.2823 10.2051 18.475 10.1356C18.6678 10.066 18.7676 9.85332 18.6981 9.66053C17.9692 7.64096 16.0365 6.28406 13.8887 6.28406C11.07 6.28406 8.77686 8.57721 8.77686 11.3959C8.77686 14.2146 11.07 16.5077 13.8887 16.5077C16.0341 16.5077 17.9662 15.1528 18.6963 13.1361C18.7661 12.9434 18.6664 12.7306 18.4737 12.6609Z"
          fill={props.fill ?? "currentColor"}
        />
        <path
          d="M2.12306 4.4615H16.11L15.5245 5.05746C15.3809 5.20367 15.383 5.43862 15.5292 5.58227C15.6735 5.72396 15.9123 5.7218 16.054 5.57759L17.2595 4.35047C17.4011 4.2063 17.3989 3.96712 17.2549 3.82577L16.0066 2.59864C15.8604 2.45495 15.6255 2.45699 15.4817 2.60313C15.3381 2.74927 15.3401 2.98426 15.4862 3.12795L16.0878 3.71933H2.12306C1.9181 3.71933 1.75195 3.88548 1.75195 4.09044C1.75195 4.2954 1.9181 4.4615 2.12306 4.4615Z"
          fill={props.fill ?? "currentColor"}
        />
        <path
          d="M18.993 11.3232C18.9634 11.1679 18.8305 11.047 18.6746 11.0275C18.5197 11.0082 18.3656 11.092 18.2968 11.2319C18.1509 11.5285 18.4552 11.8616 18.7637 11.7414C18.9293 11.6769 19.0279 11.4978 18.993 11.3232Z"
          fill={props.fill ?? "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_329_4715">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const SquareFilterIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="rounded-frame-square">
          <rect x="2" y="2" width="20" height="20" rx="2" />
        </clipPath>
      </defs>
      <g clipPath="url(#rounded-frame-square)">
        <path
          d="M2 22V17L7 11L12 16L17 13L22 18V22"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="2"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="17" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const LandscapeFilterIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 36 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="rounded-frame-landscape">
          <rect x="3" y="3" width="30" height="16" rx="2" />
        </clipPath>
      </defs>
      <g clipPath="url(#rounded-frame-landscape)">
        <path
          d="M3 19V16L10 12L18 16L26 14L33 17V19"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="30"
        height="16"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="26" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const PortraitFilterIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 22 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="rounded-frame-portrait">
          <rect x="3" y="3" width="16" height="30" rx="2" />
        </clipPath>
      </defs>
      <g clipPath="url(#rounded-frame-portrait)">
        <path
          d="M3 33V26L7 19L11 24L15 21L19 27V33"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="16"
        height="30"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const ClassicFilterIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="rounded-frame-classic">
          <rect x="3" y="3" width="26" height="20" rx="2" />
        </clipPath>
      </defs>
      <g clipPath="url(#rounded-frame-classic)">
        <path
          d="M3 23V19L9 15L17 19L24 16L29 20V23"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="26"
        height="20"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="23" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const TabletFilterIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="rounded-frame-tablet">
          <rect x="3" y="3" width="20" height="26" rx="2" />
        </clipPath>
      </defs>
      <g clipPath="url(#rounded-frame-tablet)">
        <path
          d="M3 29V24L7 18L11 23L15 20L19 25V29"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="20"
        height="26"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const TextboxIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width={props.width ?? "20"}
      height={props.height ?? "20"}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.0703 5.66406H20.1172C19.5778 5.66406 19.1406 6.10127 19.1406 6.64062C19.1406 7.17998 19.5778 7.61719 20.1172 7.61719H22.0703C22.6088 7.61719 23.0469 8.05527 23.0469 8.59375V16.4062C23.0469 16.9447 22.6088 17.3828 22.0703 17.3828H20.1172C19.5778 17.3828 19.1406 17.82 19.1406 18.3594C19.1406 18.8987 19.5778 19.3359 20.1172 19.3359H22.0703C23.6857 19.3359 25 18.0217 25 16.4062V8.59375C25 6.97832 23.6857 5.66406 22.0703 5.66406Z"
        fill={props.color ?? "currentColor"}
      />
      <path
        d="M4.88281 11.5234H5.85938V14.4531C5.85938 14.9925 6.29658 15.4297 6.83594 15.4297C7.37529 15.4297 7.8125 14.9925 7.8125 14.4531V11.5234H8.78906C9.32842 11.5234 9.76562 11.0862 9.76562 10.5469C9.76562 10.0075 9.32842 9.57031 8.78906 9.57031H4.88281C4.34346 9.57031 3.90625 10.0075 3.90625 10.5469C3.90625 11.0862 4.34346 11.5234 4.88281 11.5234Z"
        fill={props.color ?? "currentColor"}
      />
      <path
        d="M2.92969 19.3359H15.2344V21.2891H14.2578C13.7185 21.2891 13.2812 21.7263 13.2812 22.2656C13.2812 22.805 13.7185 23.2422 14.2578 23.2422H18.1641C18.7034 23.2422 19.1406 22.805 19.1406 22.2656C19.1406 21.7263 18.7034 21.2891 18.1641 21.2891H17.1875V3.71094H18.1641C18.7034 3.71094 19.1406 3.27373 19.1406 2.73438C19.1406 2.19502 18.7034 1.75781 18.1641 1.75781H14.2578C13.7185 1.75781 13.2812 2.19502 13.2812 2.73438C13.2812 3.27373 13.7185 3.71094 14.2578 3.71094H15.2344V5.66406H2.92969C1.31426 5.66406 0 6.97832 0 8.59375V16.4062C0 18.0217 1.31426 19.3359 2.92969 19.3359ZM1.95312 8.59375C1.95312 8.05527 2.39121 7.61719 2.92969 7.61719H15.2344V17.3828H2.92969C2.39121 17.3828 1.95312 16.9447 1.95312 16.4062V8.59375Z"
        fill={props.color ?? "currentColor"}
      />
    </svg>
  );
};

export const HomeIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 22}
    height={props.height ?? 22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.828 21.98H5.152A5.16 5.16 0 0 1 0 16.828V9.603c0-1.597.758-3.128 2.027-4.097l5.839-4.454a5.164 5.164 0 0 1 6.248 0l1.856 1.415V1.37c.045-1.14 1.672-1.139 1.717 0V4.2a.859.859 0 0 1-1.379.683l-3.235-2.466a3.44 3.44 0 0 0-4.166 0L3.07 6.872a3.46 3.46 0 0 0-1.352 2.73v7.226a3.44 3.44 0 0 0 3.435 3.435h11.676a3.44 3.44 0 0 0 3.435-3.435V9.603c0-1.078-.5-2.102-1.337-2.74a.859.859 0 0 1 1.042-1.366 5.18 5.18 0 0 1 2.012 4.106v7.225a5.16 5.16 0 0 1-5.152 5.152M9.273 9.915c-.593 0-1.073.48-1.073 1.073.056 1.425 2.09 1.424 2.146 0 0-.592-.48-1.073-1.073-1.073m4.507 1.073c-.056 1.425-2.09 1.424-2.146 0 .057-1.424 2.09-1.423 2.146 0m-3.434 3.435c-.057 1.424-2.09 1.423-2.146 0 .056-1.424 2.09-1.423 2.146 0m3.434 0c-.056 1.424-2.09 1.423-2.146 0 .057-1.424 2.09-1.423 2.146 0"
    ></path>
  </svg>
);

export const FolderIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 22}
    height={props.height ?? 20}
    fill="none"
    viewBox="0 0 22 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.687 19.435H4.293A4.3 4.3 0 0 1 0 15.142V4.839A4.3 4.3 0 0 1 4.293.546h3.434a4.3 4.3 0 0 1 4.207 3.434h5.753a4.3 4.3 0 0 1 4.293 4.293v6.869a4.3 4.3 0 0 1-4.293 4.293M4.293 2.263A2.58 2.58 0 0 0 1.717 4.84v10.303a2.58 2.58 0 0 0 2.576 2.576h13.394a2.58 2.58 0 0 0 2.576-2.576V8.273a2.58 2.58 0 0 0-2.576-2.576h-6.525a.86.86 0 0 1-.859-.858 2.58 2.58 0 0 0-2.576-2.576z"
    ></path>
    <path
      fill="currentColor"
      d="M7.73 5.698H4.296a.859.859 0 1 1 0-1.718H7.73a.859.859 0 1 1 0 1.718"
    ></path>
  </svg>
);

export const BrandKitIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 22}
    height={props.height ?? 22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_657_8)">
      <path d="M4.549 15.498a1.934 1.934 0 0 0-1.932 1.932c0 1.065.867 1.932 1.932 1.932a1.934 1.934 0 0 0 1.932-1.932 1.934 1.934 0 0 0-1.932-1.932m0 2.576a.645.645 0 1 1 .001-1.29.645.645 0 0 1-.001 1.29"></path>
      <path d="M20.818 13.082c.44-.594.52-1.423.12-2.115l-2.574-4.502c-.445-.771-1.384-1.123-2.222-.9a1.94 1.94 0 0 0-.92-2.093L10.762.896a1.93 1.93 0 0 0-1.986.032A1.93 1.93 0 0 0 7.126 0H1.932A1.934 1.934 0 0 0 0 1.932v18.116c0 1.065.867 1.932 1.932 1.932h18.116a1.934 1.934 0 0 0 1.932-1.932v-5.194c0-.792-.479-1.474-1.162-1.772M7.77 20.048a.645.645 0 0 1-.644.644H1.932a.645.645 0 0 1-.644-.644V14.21H7.77zm0-7.126H1.288V7.727H7.77zm0-6.483H1.288V1.932c0-.355.289-.644.644-.644h5.194c.355 0 .644.289.644.644zm1.288-3.882.18-.31a.645.645 0 0 1 .88-.236l4.46 2.576a.645.645 0 0 1 .236.88l-.745 1.294a1 1 0 0 0-.049.086l-4.962 8.625zm0 15.497 6.02-10.463 1.245-.719c.315-.182.748-.071.924.235l2.575 4.502a.646.646 0 0 1-.238.883l-10.526 6.094zm11.634 1.994a.645.645 0 0 1-.644.644h-11.1q.104-.292.11-.617l10.13-5.865h.86c.355 0 .644.289.644.644z"></path>
    </g>
    <defs>
      <clipPath id="clip0_657_8">
        <path fill="#fff" d="M0 0h21.98v21.98H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 22}
    height={props.height ?? 22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_657_22)">
      <path d="M10.833 10.588c1.455 0 2.714-.522 3.743-1.551 1.03-1.03 1.551-2.289 1.551-3.743s-.521-2.714-1.55-3.743C13.546.52 12.286 0 10.832 0S8.12.522 7.09 1.55C6.06 2.58 5.54 3.84 5.54 5.295s.52 2.714 1.55 3.743 2.289 1.55 3.743 1.55M8.001 2.462c.79-.79 1.716-1.174 2.832-1.174s2.043.384 2.832 1.174c.79.79 1.174 1.716 1.174 2.832s-.384 2.042-1.174 2.832S11.95 9.3 10.834 9.3s-2.042-.384-2.832-1.174S6.827 6.41 6.827 5.294s.384-2.043 1.174-2.832M20.098 16.902c-.03-.429-.09-.896-.178-1.39-.089-.496-.204-.966-.341-1.396a7 7 0 0 0-.575-1.302 5 5 0 0 0-.865-1.128 3.8 3.8 0 0 0-1.244-.781 4.3 4.3 0 0 0-1.587-.288c-.224 0-.441.092-.86.365-.258.169-.56.363-.897.578-.288.184-.678.355-1.16.511-.47.152-.947.23-1.418.23-.47 0-.948-.078-1.418-.23-.482-.155-.872-.327-1.16-.51-.333-.214-.635-.408-.897-.579-.418-.273-.635-.365-.86-.365a4.3 4.3 0 0 0-1.587.288 3.8 3.8 0 0 0-1.244.781 5 5 0 0 0-.865 1.128c-.238.42-.432.858-.574 1.303-.137.429-.252.899-.341 1.396-.089.492-.149.96-.178 1.389-.03.42-.044.857-.044 1.298 0 1.147.364 2.076 1.084 2.761.71.676 1.65 1.019 2.793 1.019h10.583c1.143 0 2.083-.343 2.794-1.019.719-.684 1.084-1.613 1.084-2.761 0-.443-.015-.88-.045-1.299m-1.927 3.126c-.47.447-1.093.664-1.906.664H5.682c-.813 0-1.436-.217-1.905-.664-.46-.438-.684-1.036-.684-1.828 0-.412.013-.819.04-1.209.027-.383.081-.804.161-1.25.08-.442.18-.857.3-1.232.116-.36.273-.716.468-1.059q.28-.492.636-.833c.22-.212.5-.385.827-.515.304-.12.645-.186 1.015-.195.045.024.125.07.255.154q.4.261.908.585c.38.243.87.462 1.455.65a5.9 5.9 0 0 0 1.815.292c.606 0 1.217-.098 1.815-.291.586-.19 1.076-.408 1.456-.651.346-.22.642-.412.907-.585.13-.085.21-.13.256-.154q.556.015 1.014.195c.328.13.607.303.828.515.236.225.45.506.636.833.195.343.352.7.467 1.059.12.376.221.79.3 1.231.08.448.135.869.161 1.251.028.39.042.796.042 1.209 0 .792-.224 1.39-.684 1.828"></path>
    </g>
    <defs>
      <clipPath id="clip0_657_22">
        <path fill="#fff" d="M0 0h21.98v21.98H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const CallsToActionIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 22}
    height={props.height ?? 22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <g clipPath="url(#clip0_657_20)">
      <path
        fill="currentColor"
        d="M16.752 7.875c-.56 0-1.071.213-1.456.563a2.16 2.16 0 0 0-2.913 0 2.2 2.2 0 0 0-.534-.355 4.96 4.96 0 0 0 1.119-3.13A4.96 4.96 0 0 0 8.016 0a4.96 4.96 0 0 0-4.953 4.953A4.97 4.97 0 0 0 5.85 9.406v6.041a6.54 6.54 0 0 0 6.533 6.533 6.54 6.54 0 0 0 6.534-6.533V10.04a2.167 2.167 0 0 0-2.165-2.165M4.482 4.953a3.54 3.54 0 0 1 3.534-3.534 3.54 3.54 0 0 1 3.533 3.534 3.55 3.55 0 0 1-1.368 2.791V4.953a2.17 2.17 0 0 0-2.165-2.166A2.17 2.17 0 0 0 5.85 4.953v2.791A3.55 3.55 0 0 1 4.48 4.953m13.016 10.494a5.12 5.12 0 0 1-5.115 5.114 5.12 5.12 0 0 1-5.115-5.114V4.953a.748.748 0 0 1 1.494 0v6.643a.71.71 0 1 0 1.42 0V10.04a.747.747 0 0 1 1.492 0v1.556a.71.71 0 1 0 1.418 0V10.04a.748.748 0 0 1 1.495 0v1.556a.71.71 0 1 0 1.419 0V10.04a.747.747 0 0 1 1.492 0z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_657_20">
        <path fill="#fff" d="M0 0h21.98v21.98H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const LayoutsIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M0.75 1.625C0.75 1.14175 1.14175 0.75 1.625 0.75H13.875C14.3582 0.75 14.75 1.14175 14.75 1.625V3.375C14.75 3.85825 14.3582 4.25 13.875 4.25H1.625C1.14175 4.25 0.75 3.85825 0.75 3.375V1.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 8.625C0.75 8.14175 1.14175 7.75 1.625 7.75H6.875C7.35825 7.75 7.75 8.14175 7.75 8.625V13.875C7.75 14.3582 7.35825 14.75 6.875 14.75H1.625C1.14175 14.75 0.75 14.3582 0.75 13.875V8.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 8.625C11.25 8.14175 11.6418 7.75 12.125 7.75H13.875C14.3582 7.75 14.75 8.14175 14.75 8.625V13.875C14.75 14.3582 14.3582 14.75 13.875 14.75H12.125C11.6418 14.75 11.25 14.3582 11.25 13.875V8.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogosIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12.0006 0C5.38353 0 0 5.38302 0 12C0 18.6166 5.38353 24 12.0006 24C18.6169 24 24 18.617 24 12C24 5.38302 18.6173 0 12.0006 0ZM12.0006 22.7447C6.0754 22.7447 1.2549 17.9247 1.2549 11.9996C1.2549 6.07487 6.0754 1.25446 12.0006 1.25446C17.925 1.25446 22.7451 6.07446 22.7451 11.9996C22.7451 17.9247 17.9254 22.7447 12.0006 22.7447Z"
      fill="currentColor"
    />
    <path
      d="M13.11 6.18198C13.0175 5.97033 12.7553 5.79883 12.5248 5.79883H11.4476C11.2163 5.79883 10.9549 5.97033 10.8637 6.18282L6.65601 15.9173C6.56441 16.129 6.67735 16.3013 6.90867 16.3013H8.62328C8.8546 16.3013 9.11018 16.1265 9.19468 15.9115L9.76357 14.4646C9.84807 14.2496 10.1036 14.0756 10.335 14.0756H13.5772C13.809 14.0756 14.0666 14.2488 14.1532 14.4629L14.743 15.9132C14.8296 16.1273 15.0877 16.3013 15.319 16.3013H17.0926C17.3239 16.3013 17.436 16.1298 17.3444 15.9173L13.11 6.18198ZM12.7912 12.1184H11.0616C10.8302 12.1184 10.7114 11.9436 10.7955 11.7286L11.7664 9.24431C11.8505 9.02847 11.9877 9.02847 12.073 9.24347L13.056 11.7294C13.1401 11.9444 13.0226 12.1184 12.7912 12.1184Z"
      fill="currentColor"
    />
  </svg>
);

export const ShapesIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_2083_4922)">
      <path d="M13.4033 24H24V13.4033H13.4033V24ZM14.8083 14.8083H22.595V22.595H14.8083V14.8083Z" />
      <path d="M18.2737 11.4523C21.4312 11.4523 23.9999 8.88354 23.9999 5.72607C23.9999 2.56879 21.4312 0 18.2737 0C15.1162 0 12.5476 2.56879 12.5476 5.72626C12.5476 8.88373 15.1164 11.4523 18.2737 11.4523ZM18.2737 1.40497C20.6564 1.40497 22.595 3.34351 22.595 5.72626C22.595 8.10901 20.6564 10.0474 18.2737 10.0474C15.8909 10.0474 13.9526 8.10883 13.9526 5.72607C13.9526 3.34332 15.8911 1.40497 18.2737 1.40497Z" />
      <path d="M0 10.8428H12.3142L6.1571 0L0 10.8428ZM2.41351 9.43781L6.1571 2.84528L9.9007 9.43781H2.41351Z" />
      <path d="M2.98352 13.6647L0 18.8323L2.98352 23.9999H8.95056L11.9343 18.8323L8.95056 13.6646H2.98352V13.6647ZM8.13941 22.595H3.79468L1.62231 18.8323L3.79468 15.0695H8.13941L10.3118 18.8323L8.13941 22.595Z" />
    </g>
    <defs>
      <clipPath id="clip0_2083_4922">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const ImagesIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_14_10257)">
      <path d="M20.933 0H3.067A3.07 3.07 0 0 0 0 3.067v17.866A3.07 3.07 0 0 0 3.067 24h17.866A3.07 3.07 0 0 0 24 20.933V3.067A3.07 3.07 0 0 0 20.933 0m1.653 20.933c0 .912-.741 1.653-1.653 1.653H3.067a1.655 1.655 0 0 1-1.653-1.653v-2.578l4.652-3.959a.46.46 0 0 1 .589-.003l2.914 2.42a.707.707 0 0 0 .952-.045l6.925-6.935a.45.45 0 0 1 .347-.134c.076.004.22.031.332.169l4.461 5.493zm0-7.814-3.364-4.142a1.874 1.874 0 0 0-2.776-.143l-6.47 6.48-2.418-2.009a1.87 1.87 0 0 0-2.408.014L1.414 16.5V3.067c0-.912.741-1.653 1.653-1.653h17.866c.912 0 1.653.741 1.653 1.653z"></path>
      <path d="M7.557 2.953A3.41 3.41 0 0 0 4.148 6.36 3.41 3.41 0 0 0 7.557 9.77a3.41 3.41 0 0 0 3.408-3.409 3.41 3.41 0 0 0-3.408-3.408m0 5.403c-1.1 0-1.995-.895-1.995-1.995s.895-1.995 1.995-1.995 1.995.895 1.995 1.995-.895 1.995-1.995 1.995"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_10257">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_14_10287)">
      <path d="m15.957 11.53-4.983-3.622a.6.6 0 0 0-.954.485v7.243a.6.6 0 0 0 .954.484l4.983-3.62a.596.596 0 0 0 0-.97"></path>
      <path d="M12 .002c-6.628 0-12 5.371-12 12 0 6.626 5.372 11.996 12 11.996s12-5.37 12-11.996c0-6.629-5.372-12-12-12m0 21.994c-5.52 0-9.995-4.473-9.995-9.994 0-5.519 4.475-9.997 9.995-9.997s9.995 4.478 9.995 9.997c0 5.521-4.475 9.994-9.995 9.994"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_10287">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const InformationIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g fill="currentColor" clipPath="url(#clip0_14_10291)">
      <path d="M12 0C5.367 0 0 5.368 0 12c0 6.633 5.368 12 12 12 6.633 0 12-5.367 12-12S18.632 0 12 0m0 22.125A10.12 10.12 0 0 1 1.875 12 10.12 10.12 0 0 1 12 1.875 10.12 10.12 0 0 1 22.125 12 10.12 10.12 0 0 1 12 22.125"></path>
      <path d="M12 10.047a.937.937 0 0 0-.937.937v6.037a.937.937 0 1 0 1.874 0v-6.037a.937.937 0 0 0-.937-.937M12 8.899a1.266 1.266 0 1 0 0-2.531 1.266 1.266 0 0 0 0 2.53"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_10291">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AlignLeftIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <g fill="currentColor" clipPath="url(#clip0_14_12505)">
      <path d="M1.875 3.75h7.5v2.813h-7.5zM1.875 8.438H15v2.812H1.875zM0 0h.879v15H0z"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_12505">
        <path fill="#fff" d="M0 0h15v15H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AlignCenterHorizontalIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <path
      fill="currentColor"
      d="M8.077 9.13V7.06h4.615V4.675H8.077V0H6.923v4.674H2.308V7.06h4.615v2.07H0v2.5h6.923V15h1.154v-3.37H15v-2.5z"
    ></path>
  </svg>
);

export const AlignRightIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <g fill="currentColor" clipPath="url(#clip0_14_12525)">
      <path d="M5.625 3.75h7.5v2.813h-7.5zM0 8.438h13.125v2.812H0zM14.121 0H15v15h-.879z"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_12525">
        <path fill="currentColor" d="M0 0h15v15H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AlignTopIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <g fill="currentColor" clipPath="url(#clip0_14_12530)">
      <path d="M0 0h15v.879H0zM8.445 1.765h2.836v7.563H8.445zM3.719 1.765h2.836V15H3.719z"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_12530">
        <path fill="currentColor" d="M0 0h15v15H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AlignCenterVerticalIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <path
      fill="currentColor"
      d="M15 6.998h-3.75V3.214H8.438v3.784H6.562V0H3.75v6.998H0v1.004h3.75V15h2.813V8.002h1.875v3.784h2.812V8.002H15z"
    ></path>
  </svg>
);

export const AlignBottomIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 15}
    height={props.height ?? 15}
    fill="none"
    viewBox="0 0 15 15"
  >
    <g fill="currentColor" clipPath="url(#clip0_14_12514)">
      <path d="M0 15h15v-.879H0zM8.445 13.235h2.836V5.672H8.445zM3.719 13.235h2.836V0H3.719z"></path>
    </g>
    <defs>
      <clipPath id="clip0_14_12514">
        <path fill="currentColor" d="M0 15h15V0H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const SpaceRocketLaunchIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 40;
  return (
    <svg
      fill={props.color ?? "#000000"}
      height={size}
      width={size}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 332.786 332.786"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g id="Layer_5_87_">
            {" "}
            <g>
              {" "}
              <path d="M86.564,211.083c-5.085-5.083-7-2.529-8.131-1.397c-29.282,29.282-55.278,99.935-41.535,93.034 c50.03-25.12,58.366-17.641,87.647-46.921c1.132-1.132,3.735-2.998-1.498-8.232L86.564,211.083z"></path>{" "}
              <path d="M244.419,210.691c-1.327-4.223,1.453-6.258,2.623-7.521C311.67,133.396,352.744,40.435,322.306,9.995 c-30.278-30.276-120.372,11.998-190.127,76.16c-1.38,1.271-4.1,3.678-8.966,2.662l-21.733-5.175 c-6.034-1.435-14.56,0.977-18.946,5.363L2.789,168.749c-4.386,4.387-2.961,8.764,3.167,9.726l57.677,9.064 c6.128,0.964,14.73-1.837,19.115-6.224c0,0,2.976-2.984,5.966,0.005c16.496,16.494,47.15,47.148,62.866,62.865 c3.124,3.123,0.132,6.094,0.132,6.094c-4.387,4.387-7.187,12.987-6.223,19.116l9.063,57.676c0.963,6.13,5.34,7.555,9.726,3.168 l79.746-79.746c4.385-4.386,6.798-12.91,5.361-18.944L244.419,210.691z M226.565,107.666c-13.507-13.507-13.507-35.404,0-48.909 c13.506-13.507,35.403-13.507,48.911,0c13.505,13.504,13.505,35.402,0,48.908C261.968,121.172,240.07,121.172,226.565,107.666z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const ColorWheelIcon = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 20;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_18449)">
        <path
          d="M0 10C0 4.47708 4.47708 0 10 0C15.5229 0 20 4.47708 20 10C20 15.5229 15.5229 20 10 20C4.47708 20 0 15.5229 0 10ZM10 15.9799C13.3026 15.9799 15.9799 13.3026 15.9799 10C15.9799 6.69739 13.3026 4.02008 10 4.02008C6.69739 4.02008 4.02008 6.69739 4.02008 10C4.02008 13.3026 6.69739 15.9799 10 15.9799Z"
          fill="#83D9FF"
        />
        <path
          d="M10 20.0001V15.98C10.7634 15.98 11.4929 15.8372 12.1642 15.5764L13.5396 19.3554C12.439 19.772 11.2463 20.0001 10 20.0001Z"
          fill="#3FEFEF"
        />
        <path
          d="M12.1641 15.5763C12.855 15.3079 13.4839 14.9146 14.0232 14.4241L16.6088 17.505C15.7134 18.2937 14.676 18.9251 13.5395 19.3553L12.1641 15.5763Z"
          fill="#1DD1D9"
        />
        <path
          d="M14.0234 14.4241C14.557 13.9384 15.0026 13.3577 15.3333 12.7083L18.8177 14.7203C18.2516 15.7762 17.5008 16.719 16.6089 17.505L14.0234 14.4241Z"
          fill="#17B5BA"
        />
        <path
          d="M15.8164 8.60403L19.7802 7.90503C19.9247 8.58069 20.0004 9.28137 20.0004 10.0001C20.0004 10.4668 19.9682 10.926 19.9062 11.3759L15.9424 10.6774C15.9673 10.4552 15.9803 10.2291 15.9803 10.0001C15.9803 9.5191 15.9235 9.05203 15.8164 8.60403Z"
          fill="#9BE058"
        />
        <path
          d="M15.0117 6.7359L18.4965 4.72388C19.0957 5.68732 19.5359 6.7597 19.7798 7.90488L15.816 8.60388C15.6547 7.92944 15.3795 7.29971 15.0117 6.7359Z"
          fill="#C0FF66"
        />
        <path
          d="M13.6602 5.26959L16.2458 2.18823C17.1326 2.89807 17.896 3.75577 18.4984 4.72394L15.0136 6.73596C14.6469 6.17459 14.1886 5.67883 13.6602 5.26959Z"
          fill="#FFDF46"
        />
        <path
          d="M6.69922 0.558166C7.733 0.196381 8.84369 0 10.0006 0V4.02008C9.32648 4.02008 8.67874 4.13162 8.07419 4.33716L6.69922 0.558166Z"
          fill="#FC3E81"
        />
        <path
          d="M3.75781 2.1882C4.63077 1.48965 5.62335 0.934387 6.69986 0.558105H6.70032L8.07529 4.3371C7.44388 4.55164 6.86008 4.86917 6.34341 5.26956L3.75781 2.1882Z"
          fill="#F01054"
        />
        <path
          d="M1.50391 4.72394C2.10632 3.75577 2.86972 2.89822 3.75656 2.18823L6.34216 5.26959C5.81375 5.67883 5.35538 6.17459 4.98886 6.73596L1.50391 4.72394Z"
          fill="#7884EA"
        />
        <path
          d="M0.09375 11.3758L4.05753 10.6772C4.13931 11.4011 4.35004 12.0861 4.6665 12.7082L1.18185 14.7202C0.633759 13.6985 0.257935 12.5709 0.09375 11.3758Z"
          fill="#1685FB"
        />
        <path
          d="M1.18359 14.7203L4.66809 12.7083C4.9989 13.3577 5.44446 13.9384 5.97806 14.4241L3.39246 17.505C2.50073 16.719 1.74985 15.7762 1.18359 14.7203Z"
          fill="#43A3F9"
        />
        <path
          d="M3.39062 17.505L5.97623 14.4241C6.51532 14.9146 7.14429 15.3079 7.83536 15.5763L6.45978 19.3553C5.32346 18.9251 4.28601 18.2937 3.39062 17.505Z"
          fill="#64BDFF"
        />
        <path
          d="M0.21875 7.90488C0.462585 6.7597 0.902802 5.68732 1.50201 4.72388L4.98682 6.7359C4.61908 7.29971 4.34381 7.92944 4.18253 8.60388L0.21875 7.90488Z"
          fill="#4A5BE5"
        />
        <path
          d="M15.332 12.7082C15.6483 12.0859 15.8591 11.4011 15.9409 10.6772L19.9046 11.3758C19.7404 12.5709 19.3646 13.6985 18.8165 14.7202L15.332 12.7082Z"
          fill="#1CC939"
        />
        <path
          d="M0 10.0001C0 9.28137 0.0756836 8.58069 0.220184 7.90503L4.18396 8.60403C4.07684 9.05203 4.02008 9.5191 4.02008 10.0001C4.02008 10.2291 4.03305 10.4552 4.05792 10.6774L0.0941467 11.3759C0.0321961 10.926 0 10.4668 0 10.0001Z"
          fill="#364EC6"
        />
        <path
          d="M11.9258 4.3371L13.3012 0.558105C14.3777 0.934387 15.3705 1.48965 16.2433 2.18835L13.6578 5.26956C13.141 4.86917 12.557 4.55164 11.9258 4.3371Z"
          fill="#F9B200"
        />
        <path
          d="M10 4.02008V0C11.1569 0 12.2681 0.196381 13.3018 0.558166L11.9263 4.33716C11.3219 4.13162 10.6741 4.02008 10 4.02008Z"
          fill="#FD6096"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_18449">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Opacity = (
  props: SVGAttributes<SVGElement> & { size?: number }
) => {
  const size = props.size ?? 40;
  return (
    <svg
      fill={props.color ?? "#000000"}
      height={size}
      width={size}
      viewBox="0 0 19 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_10593)">
        <path
          d="M17.4284 4.48902C16.7425 3.39867 15.8739 2.4723 14.8469 1.7355C14.5927 1.55327 14.2465 1.62222 14.0733 1.88949C13.9002 2.15679 13.9657 2.52113 14.2197 2.70335C15.1269 3.35417 15.8942 4.17249 16.5001 5.13562C16.6696 5.40507 17.0148 5.47941 17.2715 5.3007C17.5279 5.12214 17.5981 4.75874 17.4284 4.48902Z"
          fill="black"
        />
        <path
          d="M17.2692 14.7036C17.013 14.5249 16.6675 14.5987 16.4977 14.8683C15.8912 15.8311 15.1236 16.649 14.216 17.2994C13.9619 17.4814 13.8962 17.8458 14.0693 18.1132C14.2423 18.3806 14.5887 18.4496 14.8427 18.2676C15.8701 17.5314 16.7392 16.6054 17.4257 15.5153C17.5955 15.2457 17.5255 14.8823 17.2692 14.7036Z"
          fill="black"
        />
        <path
          d="M18.8228 8.0691C18.7637 7.75164 18.4711 7.54473 18.1695 7.60684C17.8678 7.66899 17.6711 7.97672 17.7302 8.29414C17.9325 9.38121 17.9454 10.5533 17.7293 11.711C17.67 12.0284 17.8666 12.3362 18.1682 12.3986C18.4709 12.461 18.7626 12.2532 18.8217 11.9367C19.052 10.7031 19.0663 9.37774 18.8228 8.0691Z"
          fill="black"
        />
        <path
          d="M11.8875 19.0902C11.8245 18.7736 11.5294 18.571 11.2285 18.637C10.8441 18.7218 10.4517 18.7773 10.0566 18.8046V1.19567C10.4517 1.22297 10.8441 1.27852 11.2285 1.36325C11.5298 1.4295 11.8245 1.22637 11.8875 0.910043C11.9505 0.593441 11.7577 0.283011 11.4568 0.216722C5.54125 -1.08695 0 3.65641 0 10.0002C0 16.3575 5.55398 21.0845 11.4568 19.7836C11.7577 19.7172 11.9505 19.4068 11.8875 19.0902Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_10593">
          <rect width="19" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AIBrainIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    width={props.width ?? 17}
    height={props.height ?? 17}
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_14_13596)">
      <path
        d="M3.96846 8.87184H3.25416C2.79848 8.87184 2.42773 8.50345 2.42773 8.05066C2.42773 7.9131 2.31627 7.80164 2.17871 7.80164C2.04115 7.80164 1.92969 7.9131 1.92969 8.05066C1.92969 8.77807 2.52386 9.36989 3.25419 9.36989H3.96846C4.10602 9.36989 4.21748 9.25842 4.21748 9.12086C4.21748 8.9833 4.10602 8.87184 3.96846 8.87184Z"
        fill="white"
      />
      <path
        d="M6.30794 10.715H4.18055C3.47791 10.715 2.90625 11.2843 2.90625 11.9842C2.90625 12.1217 3.01771 12.2332 3.15527 12.2332C3.29283 12.2332 3.4043 12.1217 3.4043 11.9842C3.4043 11.559 3.7525 11.213 4.18055 11.213H6.30794C6.4455 11.213 6.55697 11.1015 6.55697 10.964C6.55697 10.8264 6.4455 10.715 6.30794 10.715Z"
        fill="white"
      />
      <path
        d="M8.33663 10.715H7.30371C7.16615 10.715 7.05469 10.8264 7.05469 10.964C7.05469 11.1015 7.16615 11.213 7.30371 11.213H8.33663C8.47419 11.213 8.58565 11.1015 8.58565 10.964C8.58565 10.8264 8.47415 10.715 8.33663 10.715Z"
        fill="white"
      />
      <path
        d="M6.58608 5.87622C6.44852 5.87622 6.33706 5.98772 6.33706 6.12524C6.33706 6.83732 5.75434 7.41661 5.03809 7.41661C4.90053 7.41661 4.78906 7.52808 4.78906 7.66564C4.78906 7.8032 4.90053 7.91466 5.03809 7.91466C6.02897 7.91466 6.83511 7.11194 6.83511 6.12524C6.83511 5.98772 6.72364 5.87622 6.58608 5.87622Z"
        fill="white"
      />
      <path
        d="M6.12632 2.11163C5.53146 2.07345 5.01568 2.52445 4.9771 3.11732C4.96817 3.25458 5.07219 3.37305 5.20942 3.38202C5.21493 3.38238 5.22041 3.38255 5.22586 3.38255C5.35601 3.38255 5.46551 3.28141 5.47411 3.14969C5.49483 2.83068 5.77308 2.5884 6.09432 2.60865C6.23168 2.61785 6.34998 2.51342 6.35881 2.37616C6.36768 2.2389 6.26359 2.1205 6.12632 2.11163Z"
        fill="white"
      />
      <path
        d="M5.29199 11.8237C5.15443 11.8237 5.04297 11.9352 5.04297 12.0728C5.04297 12.2103 5.15443 12.3218 5.29199 12.3218C5.70321 12.3218 6.03777 12.6541 6.03777 13.0626C6.03777 13.4711 5.70321 13.8035 5.29199 13.8035C5.15443 13.8035 5.04297 13.9149 5.04297 14.0525C5.04297 14.1901 5.15443 14.3015 5.29199 14.3015C5.97784 14.3015 6.53581 13.7458 6.53581 13.0626C6.53581 12.3795 5.97784 11.8237 5.29199 11.8237Z"
        fill="white"
      />
      <path
        d="M7.83887 5.95972C7.70131 5.95972 7.58984 6.07118 7.58984 6.20874C7.58984 6.3463 7.70131 6.45776 7.83887 6.45776C8.16921 6.45776 8.43798 6.72462 8.43798 7.05266C8.43798 7.38074 8.16921 7.64763 7.83887 7.64763C7.70131 7.64763 7.58984 7.75909 7.58984 7.89665C7.58984 8.03421 7.70131 8.14568 7.83887 8.14568C8.44386 8.14568 8.93603 7.65533 8.93603 7.05266C8.93603 6.45003 8.44386 5.95972 7.83887 5.95972Z"
        fill="white"
      />
      <path
        d="M3.45215 4.37646C3.31459 4.37646 3.20312 4.48793 3.20312 4.62549C3.20312 4.76305 3.31459 4.87451 3.45215 4.87451C4.01972 4.87451 4.48145 5.33338 4.48145 5.89743C4.48145 6.46152 4.01972 6.92042 3.45215 6.92042C3.31459 6.92042 3.20312 7.03188 3.20312 7.16945C3.20312 7.30701 3.31459 7.41847 3.45215 7.41847C4.29431 7.41847 4.97949 6.73614 4.97949 5.89743C4.97949 5.05876 4.29431 4.37646 3.45215 4.37646Z"
        fill="white"
      />
      <path
        d="M15.1575 4.36511C14.6894 4.36511 14.3086 4.74459 14.3086 5.21103C14.3086 5.6775 14.6894 6.05698 15.1575 6.05698C15.6255 6.05698 16.0063 5.6775 16.0063 5.21103C16.0063 4.74459 15.6255 4.36511 15.1575 4.36511ZM15.1575 5.55896C14.9641 5.55896 14.8067 5.40291 14.8067 5.21106C14.8066 5.01925 14.964 4.86319 15.1575 4.86319C15.3509 4.86319 15.5083 5.01925 15.5083 5.21106C15.5083 5.40288 15.3509 5.55896 15.1575 5.55896Z"
        fill="white"
      />
      <path
        d="M15.9895 10.7385C15.5214 10.7385 15.1406 11.118 15.1406 11.5845C15.1406 12.0509 15.5214 12.4304 15.9895 12.4304C16.4576 12.4304 16.8383 12.0509 16.8383 11.5845C16.8383 11.118 16.4576 10.7385 15.9895 10.7385ZM15.9895 11.9323C15.7961 11.9323 15.6387 11.7763 15.6387 11.5845C15.6387 11.3927 15.7961 11.2366 15.9895 11.2366C16.1829 11.2366 16.3403 11.3926 16.3403 11.5845C16.3403 11.7763 16.1829 11.9323 15.9895 11.9323Z"
        fill="white"
      />
      <path
        d="M15.468 7.75395C15.3243 7.75399 15.189 7.78985 15.0702 7.8529L14.5848 7.36986C14.4873 7.27284 14.3297 7.27327 14.2327 7.37072C14.1356 7.46821 14.136 7.62586 14.2335 7.72287L14.7177 8.20469C14.6549 8.32276 14.6191 8.45719 14.6191 8.59987C14.6191 9.06634 14.9999 9.44582 15.468 9.44582C15.9361 9.44582 16.3168 9.06634 16.3168 8.59987C16.3168 8.13343 15.936 7.75395 15.468 7.75395ZM15.468 8.9478C15.2745 8.9478 15.1172 8.79175 15.1172 8.5999C15.1172 8.40812 15.2745 8.25203 15.468 8.25203C15.6614 8.25203 15.8188 8.40809 15.8188 8.5999C15.8188 8.79172 15.6614 8.9478 15.468 8.9478Z"
        fill="white"
      />
      <path
        d="M14.9075 13.3379C14.4394 13.3379 14.0586 13.7174 14.0586 14.1838C14.0586 14.6503 14.4394 15.0298 14.9075 15.0298C15.3756 15.0298 15.7563 14.6503 15.7563 14.1838C15.7563 13.7174 15.3756 13.3379 14.9075 13.3379ZM14.9075 14.5317C14.714 14.5317 14.5566 14.3757 14.5566 14.1838C14.5566 13.992 14.714 13.8359 14.9075 13.8359C15.1009 13.8359 15.2583 13.992 15.2583 14.1838C15.2583 14.3757 15.1009 14.5317 14.9075 14.5317Z"
        fill="white"
      />
      <path
        d="M11.9943 4.67981C12.1526 4.67981 12.3415 4.60185 12.4537 4.49022L13.4157 3.53291C13.5124 3.57113 13.6176 3.59238 13.7277 3.59238C14.1958 3.59238 14.5766 3.2129 14.5766 2.74643C14.5766 2.27999 14.1958 1.90055 13.7277 1.90055C13.2597 1.90055 12.8789 2.28003 12.8789 2.74643C12.8789 2.92158 12.9326 3.0845 13.0245 3.21964L12.1025 4.13711C12.083 4.1558 12.0213 4.1813 11.9943 4.18177H9.93888V2.53333H10.517C10.624 2.87861 10.9472 3.13026 11.3283 3.13026C11.7964 3.13026 12.1772 2.75078 12.1772 2.28431C12.1772 1.81787 11.7964 1.43839 11.3283 1.43839C10.9472 1.43839 10.624 1.69001 10.517 2.03529H9.93888V1.99757C9.93888 0.896086 9.0389 0 7.93264 0C7.14181 0 6.43239 0.460926 6.10866 1.1657C6.05889 1.16218 6.00925 1.16038 5.96001 1.16038C4.81025 1.16038 3.87177 2.07832 3.84511 3.21685C3.74583 3.20271 3.64542 3.19557 3.54458 3.19557C2.37809 3.19557 1.42911 4.14046 1.42911 5.30187C1.42911 5.55681 1.47384 5.80347 1.56229 6.03812C0.691572 6.55476 0.160156 7.47768 0.160156 8.5C0.160156 9.04891 0.31651 9.58249 0.612283 10.043C0.855928 10.4223 1.18417 10.738 1.57026 10.9665C1.47749 11.207 1.42911 11.4644 1.42911 11.7229C1.42911 12.2357 1.61631 12.7297 1.95621 13.1142C2.04729 13.2172 2.20467 13.2269 2.30773 13.1358C2.4108 13.0447 2.42046 12.8874 2.32935 12.7843C2.06997 12.4909 1.92716 12.114 1.92716 11.7229C1.92716 11.4598 1.98935 11.2088 2.1118 10.977C2.25796 10.6993 2.48504 10.4649 2.77228 10.3094C2.89324 10.2439 2.93816 10.0928 2.87265 9.97186C2.80718 9.85087 2.656 9.80588 2.53511 9.87149C2.23764 10.0326 1.98965 10.2586 1.80421 10.5261C1.09213 10.0977 0.658203 9.3403 0.658203 8.5C0.658203 7.60152 1.15585 6.79608 1.9593 6.38841C1.9593 6.38841 2.42421 6.12976 3.04139 6.12976C3.17895 6.12976 3.29041 6.0183 3.29041 5.88074C3.29041 5.74318 3.17895 5.63171 3.04139 5.63171C2.67961 5.63171 2.3333 5.69862 2.01402 5.82037C1.95678 5.65436 1.92723 5.48087 1.92723 5.30191C1.92723 4.41509 2.65278 3.69365 3.54465 3.69365C3.71229 3.69365 3.87814 3.71931 4.03758 3.76995C4.1193 3.79588 4.20858 3.77798 4.27396 3.72254C4.33937 3.66709 4.37164 3.58195 4.35939 3.49709C4.34827 3.41979 4.34262 3.34229 4.34262 3.26672C4.34262 2.37993 5.06821 1.65846 5.96008 1.65846C6.04767 1.65846 6.13718 1.66597 6.22627 1.68061C6.99187 1.80725 7.5775 2.47008 7.5775 3.26672C7.5775 3.40428 7.68896 3.51575 7.82653 3.51575C7.96409 3.51575 8.07555 3.40428 8.07555 3.26672C8.07555 2.33365 7.46278 1.54086 6.61697 1.26507C6.8799 0.797506 7.37961 0.498047 7.93264 0.498047C8.76425 0.498047 9.44083 1.17074 9.44083 1.99757V2.02522H8.96187C8.82431 2.02522 8.71285 2.13669 8.71285 2.27425C8.71285 2.41181 8.82431 2.52327 8.96187 2.52327H9.44083V4.18173H7.42673C6.97101 4.18173 6.60027 3.81338 6.60027 3.36062C6.60027 3.22306 6.4888 3.1116 6.35124 3.1116C6.21368 3.1116 6.10222 3.22306 6.10222 3.36062C6.10222 4.088 6.69639 4.67978 7.42673 4.67978H9.44083V8.87188H5.4014C5.26384 8.87188 5.15238 8.98334 5.15238 9.1209C5.15238 9.25846 5.26384 9.36992 5.4014 9.36992H9.44083V12.789H8.67131C7.96867 12.789 7.39704 13.3584 7.39704 14.0582C7.39704 14.1958 7.50851 14.3073 7.64607 14.3073C7.78363 14.3073 7.89509 14.1958 7.89509 14.0582C7.89509 13.633 8.24329 13.2871 8.67131 13.2871H9.44083V15.0024C9.44083 15.0415 9.43884 15.0802 9.43588 15.1185H8.96187C8.82431 15.1185 8.71285 15.23 8.71285 15.3676C8.71285 15.5051 8.82431 15.6166 8.96187 15.6166H9.30798C9.07154 16.1379 8.54421 16.502 7.93264 16.502C7.38333 16.502 6.88545 16.2056 6.62119 15.7425C6.92197 15.6443 7.19879 15.4791 7.43201 15.2541C7.53098 15.1586 7.53381 15.001 7.43831 14.902C7.34282 14.803 7.18517 14.8002 7.08623 14.8957C6.84843 15.1251 6.55116 15.2732 6.23015 15.3268C6.13964 15.3419 6.04876 15.3496 5.96001 15.3496C5.06814 15.3496 4.34255 14.6281 4.34255 13.7413C4.34255 13.7186 4.34392 13.6951 4.34501 13.6718C4.54602 13.59 4.73485 13.478 4.90326 13.3374C5.00884 13.2493 5.02295 13.0923 4.9348 12.9867C4.84664 12.8811 4.69218 12.8702 4.58404 12.9551C4.08433 13.3477 3.60103 13.3415 3.40769 13.3255C3.27023 13.3139 3.1503 13.416 3.13888 13.5531C3.12749 13.6901 3.22939 13.8104 3.36645 13.8219C3.52566 13.835 3.68786 13.8304 3.84557 13.8079C3.88096 14.9387 4.8159 15.8477 5.96004 15.8477C6.01045 15.8477 6.06128 15.8458 6.11228 15.842C6.43774 16.5422 7.14573 17 7.93264 17C9.03887 17 9.93888 16.1039 9.93888 15.0024V14.4521H11.259C11.286 14.4526 11.3477 14.4781 11.3671 14.4967L11.9608 15.0875C11.8805 15.2167 11.834 15.3689 11.834 15.5317C11.834 15.9982 12.2148 16.3776 12.6828 16.3776C13.1509 16.3776 13.5317 15.9982 13.5317 15.5317C13.5317 15.0652 13.1509 14.6857 12.6828 14.6857C12.5598 14.6857 12.4429 14.7122 12.3371 14.7594L11.7184 14.1437C11.6062 14.032 11.4173 13.9541 11.2591 13.9541H9.93888V12.6229H12.1037C12.2107 12.9682 12.5339 13.2198 12.915 13.2198C13.3831 13.2198 13.7639 12.8403 13.7639 12.3739C13.7639 11.9074 13.3831 11.5279 12.915 11.5279C12.5339 11.5279 12.2107 11.7795 12.1037 12.1249H9.93888V10.4567H12.5294C12.6364 10.802 12.9596 11.0537 13.3408 11.0537C13.8089 11.0537 14.1896 10.6742 14.1896 10.2077C14.1896 9.74123 13.8088 9.36175 13.3408 9.36175C12.9596 9.36175 12.6364 9.61337 12.5294 9.95868H9.93888V8.14615H10.5557C10.6627 8.4914 10.9859 8.74305 11.367 8.74305C11.8351 8.74305 12.2159 8.36357 12.2159 7.89713C12.2159 7.43066 11.8351 7.05118 11.367 7.05118C10.9859 7.05118 10.6627 7.30279 10.5557 7.64811H9.93888V6.21104H12.6522C12.6792 6.21154 12.7409 6.23697 12.7603 6.25563L13.2718 6.76471C13.3204 6.81305 13.3839 6.83722 13.4475 6.83722C13.5114 6.83722 13.5753 6.81275 13.624 6.76384C13.721 6.66636 13.7206 6.50868 13.6231 6.41166L13.1116 5.90259C12.9994 5.79096 12.8105 5.713 12.6523 5.713H9.93888V4.67981H11.9943ZM13.7277 2.39856C13.9212 2.39856 14.0785 2.55462 14.0785 2.7464C14.0785 2.93821 13.9212 3.0943 13.7277 3.0943C13.5343 3.0943 13.3769 2.93824 13.3769 2.7464C13.3769 2.55462 13.5343 2.39856 13.7277 2.39856ZM11.3283 1.93644C11.5218 1.93644 11.6792 2.09249 11.6792 2.28431C11.6792 2.47612 11.5218 2.63221 11.3283 2.63221C11.1349 2.63221 10.9775 2.47616 10.9775 2.28431C10.9775 2.09249 11.1349 1.93644 11.3283 1.93644ZM12.6828 15.1838C12.8763 15.1838 13.0337 15.3398 13.0337 15.5317C13.0337 15.7235 12.8763 15.8796 12.6828 15.8796C12.4894 15.8796 12.332 15.7235 12.332 15.5317C12.332 15.3398 12.4894 15.1838 12.6828 15.1838ZM12.915 12.026C13.1085 12.026 13.2659 12.182 13.2659 12.3739C13.2659 12.5657 13.1085 12.7218 12.915 12.7218C12.7216 12.7218 12.5642 12.5657 12.5642 12.3739C12.5642 12.1821 12.7216 12.026 12.915 12.026ZM13.3407 9.8598C13.5342 9.8598 13.6916 10.0159 13.6916 10.2077C13.6916 10.3995 13.5342 10.5556 13.3407 10.5556C13.1473 10.5556 12.9899 10.3996 12.9899 10.2077C12.9899 10.0159 13.1473 9.8598 13.3407 9.8598ZM11.367 7.54923C11.5605 7.54923 11.7179 7.70528 11.7179 7.89713C11.7179 8.08891 11.5605 8.245 11.367 8.245C11.1736 8.245 11.0162 8.08895 11.0162 7.89713C11.0162 7.70528 11.1736 7.54923 11.367 7.54923Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_14_13596">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BorderRadiusIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      fill="none"
      stroke={props.fill ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 9V6a3 3 0 0 1 3-3h3" />
      <path d="M15 3h3a3 3 0 0 1 3 3v3" />
      <path d="M21 15v3a3 3 0 0 1-3 3h-3" />
      <path d="M9 21H6a3 3 0 0 1-3-3v-3" />
    </svg>
  );
};

export const WorkspaceIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "16"}
      height={props.height ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M0.75 1.625C0.75 1.14175 1.14175 0.75 1.625 0.75H13.875C14.3582 0.75 14.75 1.14175 14.75 1.625V3.375C14.75 3.85825 14.3582 4.25 13.875 4.25H1.625C1.14175 4.25 0.75 3.85825 0.75 3.375V1.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 8.625C0.75 8.14175 1.14175 7.75 1.625 7.75H6.875C7.35825 7.75 7.75 8.14175 7.75 8.625V13.875C7.75 14.3582 7.35825 14.75 6.875 14.75H1.625C1.14175 14.75 0.75 14.3582 0.75 13.875V8.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 8.625C11.25 8.14175 11.6418 7.75 12.125 7.75H13.875C14.3582 7.75 14.75 8.14175 14.75 8.625V13.875C14.75 14.3582 14.3582 14.75 13.875 14.75H12.125C11.6418 14.75 11.25 14.3582 11.25 13.875V8.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RadiusIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width={props.width ?? "16"}
      height={props.height ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1021_5257)">
        <path
          d="M15.5312 0H7.96875C5.84022 0 3.83909 0.828875 2.334 2.334C0.828875 3.83909 0 5.84022 0 7.96875V15.5312C0 15.7901 0.209875 16 0.46875 16C0.727625 16 0.9375 15.7901 0.9375 15.5312V7.96875C0.9375 4.09172 4.09172 0.9375 7.96875 0.9375H15.5312C15.7901 0.9375 16 0.727625 16 0.46875C16 0.209875 15.7901 0 15.5312 0Z"
          fill={props.fill ?? "currentColor"}
        />
        <path
          d="M12.0502 11.3873L8.88559 8.22269L11.8324 7.486C12.0315 7.43622 12.1751 7.26275 12.1867 7.05791C12.1984 6.85303 12.0754 6.66441 11.8833 6.59234L4.38334 3.77984C4.21128 3.71534 4.01728 3.75728 3.88728 3.88728C3.75728 4.01725 3.71528 4.21122 3.77984 4.38334L6.59234 11.8833C6.66125 12.0671 6.83672 12.1875 7.03109 12.1875C7.04 12.1875 7.04894 12.1873 7.05791 12.1868C7.26278 12.1751 7.43622 12.0315 7.486 11.8325L8.22269 8.88563L11.3873 12.0502C11.5703 12.2333 11.8671 12.2333 12.0502 12.0502C12.2332 11.8672 12.2332 11.5704 12.0502 11.3873ZM7.85506 7.51397C7.85125 7.51494 7.84756 7.51616 7.84378 7.51722C7.83903 7.51853 7.83425 7.51984 7.82953 7.52131C7.81847 7.52475 7.80756 7.5285 7.79691 7.53272C7.79266 7.53441 7.78847 7.53628 7.78425 7.53806C7.77528 7.54191 7.76644 7.54597 7.75775 7.55034C7.75319 7.55263 7.74869 7.55503 7.74419 7.55747C7.73481 7.56259 7.72563 7.568 7.71666 7.57375C7.71388 7.57553 7.71106 7.57719 7.70831 7.57903C7.69769 7.58616 7.68747 7.59378 7.67747 7.60172C7.67447 7.60413 7.6715 7.60656 7.66853 7.60903C7.64694 7.62706 7.62703 7.64697 7.60903 7.66856C7.60656 7.6715 7.60416 7.67444 7.60178 7.67744C7.59375 7.68753 7.586 7.69791 7.57881 7.70869C7.57713 7.71122 7.57562 7.71378 7.574 7.71634C7.56816 7.72547 7.56266 7.73481 7.55744 7.74434C7.55503 7.74875 7.55272 7.75316 7.55047 7.75759C7.546 7.76647 7.54181 7.77553 7.53788 7.78472C7.53625 7.7885 7.53456 7.79222 7.53306 7.79603C7.52869 7.80703 7.52484 7.81828 7.52128 7.82969C7.51984 7.83428 7.51859 7.83888 7.51731 7.8435C7.51625 7.84734 7.51497 7.85113 7.514 7.85503L6.94159 10.1447L5.01975 5.01972L10.1447 6.94156L7.85506 7.51397Z"
          fill={props.fill ?? "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1021_5257">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UppercaseIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      viewBox="0 0 272 242"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.7614 195.847C34.8011 195.847 28.6222 194.687 23.2244 192.366C17.8741 189.999 13.6364 186.448 10.5114 181.713C7.43371 176.931 5.89489 170.941 5.89489 163.744C5.89489 157.684 6.96023 152.57 9.09091 148.403C11.2216 144.237 14.1572 140.851 17.8977 138.247C21.6383 135.643 25.947 133.678 30.8239 132.352C35.7008 130.979 40.9091 130.056 46.4489 129.582C52.6515 129.014 57.6468 128.422 61.4347 127.807C65.2225 127.144 67.9688 126.221 69.6733 125.037C71.4252 123.806 72.3011 122.078 72.3011 119.852V119.497C72.3011 115.851 71.0464 113.034 68.5369 111.045C66.0275 109.057 62.642 108.062 58.3807 108.062C53.7879 108.062 50.0947 109.057 47.3011 111.045C44.5076 113.034 42.732 115.78 41.9744 119.284L9.94318 118.148C10.8902 111.519 13.3286 105.6 17.2585 100.392C21.2358 95.1364 26.6809 91.017 33.5938 88.0341C40.554 85.0038 48.911 83.4886 58.6648 83.4886C65.625 83.4886 72.0407 84.3172 77.9119 85.9744C83.7831 87.5843 88.8968 89.9517 93.2528 93.0767C97.6089 96.1544 100.971 99.9422 103.338 104.44C105.753 108.938 106.96 114.076 106.96 119.852V194H74.2898V178.801H73.4375C71.4962 182.494 69.0104 185.619 65.9801 188.176C62.9972 190.733 59.4697 192.651 55.3977 193.929C51.3731 195.207 46.8277 195.847 41.7614 195.847ZM52.4858 173.119C56.2263 173.119 59.5881 172.362 62.571 170.847C65.6013 169.331 68.0161 167.248 69.8153 164.597C71.6146 161.898 72.5142 158.773 72.5142 155.222V144.852C71.5199 145.373 70.3125 145.847 68.892 146.273C67.5189 146.699 66.0038 147.101 64.3466 147.48C62.6894 147.859 60.9849 148.19 59.233 148.474C57.4811 148.759 55.8002 149.019 54.1903 149.256C50.9233 149.777 48.1297 150.581 45.8097 151.67C43.5369 152.759 41.785 154.18 40.554 155.932C39.3703 157.636 38.7784 159.672 38.7784 162.04C38.7784 165.638 40.0568 168.384 42.6136 170.278C45.2178 172.172 48.5085 173.119 52.4858 173.119ZM159.659 194H121.875L170.952 48.5455H217.756L266.832 194H229.048L194.886 85.1932H193.75L159.659 194ZM154.616 136.756H233.594V163.46H154.616V136.756Z"
        fill={props.fill ?? "currentColor"}
      />
      <path
        d="M96.144 47.8308V30L136 53L96.144 76V58.1692H17V47.8308H96.144Z"
        fill={props.fill ?? "currentColor"}
        stroke={props.stroke ?? "currentColor"}
      />
    </svg>
  );
};

export const AddCommentIcon = ({ size }: { size: number }) => {
  return (
    <div style={{ position: "relative", marginRight: 4 }}>
      <ChatIcon
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        size={size}
      />
      <PlusIcon
        weight="bold"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        size={size / 2}
      />
    </div>
  );
};
